import * as API from '../api'
export const FETCH_KEYWORD = 'FETCH_KEYWORD'
export const FETCHING_KEYWORD = 'FETCHING_KEYWORD'
export const FETCH_KEYWORD_ERROR = 'FETCH_KEYWORD_ERROR'
export const FETCH_KEYWORDS = 'FETCH_KEYWORDS'
export const FETCHING_KEYWORDS = 'FETCHING_KEYWORDS'
export const FETCH_KEYWORDS_ERROR = 'FETCH_KEYWORDS_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_KEYWORD = 'CHANGE_KEYWORD'
export const DELETE_KEYWORD = 'DELETE_KEYWORD'
export const ADD_KEYWORD = 'ADD_KEYWORD'
export const EDIT_KEYWORD = 'EDIT_KEYWORD'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_KEYWORD = 'NEW_FORM_KEYWORD'
export const KEYWORD_FORM_ERROR = 'KEYWORD_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeKeyword = keyword => {
  return dispatch => {
    dispatch({ type: CHANGE_KEYWORD, keyword })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const handleKeywordError = (res, dispatch) => {
  const { data: errorMessage = '' } = res
  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: KEYWORD_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormKeyword = keyword => {
  return dispatch => {
    dispatch({ type: NEW_FORM_KEYWORD })
  }
}

export const setKeywordFormTouched = keyword => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreKeyword = id => {
  return dispatch => {
    dispatch({ type: FETCHING_KEYWORDS })
    return API.keywords
      .restoreKeyword(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_KEYWORD, keyword: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_KEYWORDS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleKeywordError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchKeywords = options => {
  return dispatch => {
    dispatch({ type: FETCHING_KEYWORDS })
    return API.keywords
      .getKeywords(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_KEYWORDS,
          keywords: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_KEYWORDS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const deleteKeyword = id => {
  return dispatch => {
    dispatch({ type: FETCHING_KEYWORDS })
    return API.keywords
      .deleteKeyword(id)
      .then(response => {
        const { data = {} } = response
        dispatch({ type: DELETE_KEYWORD, keyword: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_KEYWORDS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addKeyword = keyword => {
  return dispatch => {
    dispatch({ type: FETCHING_KEYWORDS })
    dispatch({ type: FETCHING_KEYWORD })
    return API.keywords
      .addKeyword(keyword)
      .then(({ data }) => {
        dispatch({ type: ADD_KEYWORD, keyword: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleKeywordError(response, dispatch)
        dispatch({
          type: FETCH_KEYWORDS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editKeyword = keyword => {
  return dispatch => {
    dispatch({ type: FETCHING_KEYWORDS })
    dispatch({ type: FETCHING_KEYWORD })
    return API.keywords
      .editKeyword(keyword)
      .then(({ data }) => {
        dispatch({ type: EDIT_KEYWORD, keyword: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_KEYWORDS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleKeywordError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchKeyword = id => {
  return dispatch => {
    dispatch({ type: FETCHING_KEYWORD, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.keywords
      .getKeyword(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_KEYWORD, keyword: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_KEYWORD_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/keywords.js